import { module } from 'stereomodularjs';
import Billeterie from './Billeterie.js';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.index = this.el.dataset.dateIndex;
        if (window.billeterieDate === undefined) {
            window.billeterieDate = [];
        }
        window.billeterieDate.push(this);
        this.el.addEventListener('click', (e) => {
            e.preventDefault();
            this.optionClick(this.index);
        });
    }

    optionClick(i, updateBilleterie = true) {
        if (updateBilleterie) {
            this.update(i);
        }

        if (i != this.index) {
            return;
        }

        document.querySelectorAll('.js-multiple-dates').forEach((el) => {
            el.classList.remove('-is-active');
        });

        this.el.closest('.js-multiple-dates').classList.add('-is-active');

        window.locomotiveScroll.scrollTo(0, {
            duration: 0.5,
            lerp: 0,
        });

    }

    update(i) {
        if (window.billeterie) {
            window.billeterie.forEach((billeterie) => {
                if (billeterie instanceof Billeterie) {
                    billeterie.switchDate(i);
                }
            });
        }
    }
}
